import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, of } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientLogService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  log(level: 'info' | 'warn' | 'error', tag: string, message: string, data?: unknown): void {
    const prefix = `[GFH ${tag}]`;
    const line = `${prefix} ${message}`;

    if (level === 'error') {
      console.error(line, data ?? '');
    } else if (level === 'warn') {
      console.warn(line, data ?? '');
    } else {
      console.log(line, data ?? '');
    }

    this.http.post(`${this.apiUrl}/client_log`, {
      level,
      tag,
      message,
      data: data ?? null,
      ts: new Date().toISOString(),
      userAgent: navigator.userAgent,
      url: window.location.href,
      environment: environment.environmentName,
    }).pipe(catchError(() => of(null))).subscribe();
  }
}
